export default "__VITE_ASSET__BJhC8P$e__"